import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { MdMailOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AdminHelpers from "../../../services/admin/admin.service";
import UserAdminService from "../../../services/admin/admin_users.service";
import ExportExcel from "../../../utils/ExportExcel";
import Adminroutes from "../routes";
import { BsFillImageFill } from "react-icons/bs";
export const ExcelDataExport = [
  {
    SN: "1",
    "First Name": "Fabgemi",
    "Last Name": "Yemolee",
    "User Category": "Staff",
    Phone: "0806975845",
    Email: "a@gmail.com",
    Gender: "Male",
    Role: "Super Admin",
    DOB: "01-10-2000",
  },
];
const NewUser = () => {
  const navigate = useNavigate();
  const [gender, setGender] = useState<any[]>([]);
  const [category, setCategory] = useState<any[]>([
    "Trainer",
    "MIS Director",
    "Super Admin",
    "Director General",
    "MIS Admin",
  ]);
  // const [category, setCategory] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [departments, setDepartments] = useState<any[]>([]);
  const toast = useToast();
  const courseFormatRef = useRef<HTMLSelectElement>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filename, setFilename] = useState("");
  const [batchFile, setbatchFile] = useState<FormData | null>(null);
  useEffect(() => {
    AdminHelpers.getRoles().then((res) => {
      setRoles(res.data);
    });
    AdminHelpers.getDepartments().then((res) => {
      setDepartments(res.data);
    });
    const maingender = [
      {
        id: "1",
        title: "male",
      },
      {
        id: "2",
        title: "female",
      },
    ];
    setGender(maingender);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      const regex: any = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      console.log(values.password, values.confirm_password);
      if (!values.firstName) {
        errors.firstName = "Firstname is required";
      }
      if (!values.lastName) {
        errors.lastName = "Lastname is required";
      }
      if (!values.password || values.password.length < 6) {
        errors.password = "Password must be at least 6 characters long";
      }
      if (values.password !== values.confirm_password) {
        errors.confirm_password = "Password does not match";
      }

      if (!values.emailAddress) {
        errors.emailAddress = "Email Address is required";
      }
      if (!regex.test(values.emailAddress)) {
        errors.emailAddress = "Please enter a valid email address";
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number is required";
      }
      if (
        values.phoneNumber.toString().length < 10 ||
        values.phoneNumber.toString().length > 10
      ) {
        errors.phoneNumber = "Please enter valid phone number";
      }
      if (!values.dob) {
        errors.dob = "Date of Birth is required";
      }
      if (new Date().getFullYear() - new Date(values.dob).getFullYear() < 0) {
        errors.dob = "Please select valid date";
      } else if (
        new Date().getFullYear() - new Date(values.dob).getFullYear() <
        15
      ) {
        errors.dob = "Minimum age should be 15years";
      }
      if (!values.gender) {
        errors.gender = "Gender is required";
      }
      if (
        (values.category === "MIS Director" ||
          values.category === "MIS Admin") &&
        !values.department_id
      ) {
        errors.department_id = "Required";
      }

      return errors;
    },
    initialValues: {
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
      dob: "",
      gender: "",
      password: "",
      confirm_password: "",
      category: "",
      // role: "",
      department_id: "",
    },
    onSubmit: async (values) => {
      // navigate(routes.VerifyEmail)

      const preRegInfo: any = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.emailAddress,
        phone: values.phoneNumber.toString(),
        dob: values.dob,
        gender: values.gender,
        password: values.password,
        // role: values.role,
        category: values.category,
        password_confirmation: values.confirm_password,
        department_id: values.department_id,
      };

      try {
        const preReg = await UserAdminService.createUser(preRegInfo);
        if (preReg) {
          toast({
            title: "User Management",
            description: `User created successfully`,
            status: "success",
          });
          navigate(Adminroutes.UserRoles);
        }
      } catch (error: any) {
        if (error.response.data.message) {
          for (const [_, value] of Object.entries(
            error.response.data.message
          )) {
            if (value) {
              const messages: any = value;

              messages.map((each: any) => {
                toast({
                  title: "User Management",
                  description: `${each}`,
                  status: "error",
                  duration: 4000,
                });
              });
            }
          }
        } else {
          toast({
            title: "User Management",
            description: `Something went wrong, try again`,
            status: "error",
          });
        }
      }
    },
  });
  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "30px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  // const onDrop = useCallback((acceptedFiles: File[]) => {
  //   if (!acceptedFiles.length) {
  //     toast({
  //       title: "File Upload",
  //       description: "Invalid file uploaded",
  //       status: "error",
  //     });
  //     setbatchFile(null);
  //   } else {
  //     const formData = new FormData();
  //     const file = acceptedFiles[0];

  //     formData.append("users", file);
  //     setbatchFile(formData);

  //     setFilename(file.name);
  //     toast({
  //       title: "File Upload",
  //       description: "Your file is ready for upload",
  //       status: "success",
  //     });
  //   }
  // }, []);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (!acceptedFiles.length) {
      toast({
        title: "File Upload",
        description: "No file uploaded",
        status: "error",
      });
      setbatchFile(null);
    } else {
      const file = acceptedFiles[0];
      const validExcelTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
      ];

      if (!validExcelTypes.includes(file.type)) {
        toast({
          title: "File Upload",
          description: "Invalid file type. Please upload an Excel file.",
          status: "error",
        });
        setbatchFile(null);
      } else {
        const formData = new FormData();
        formData.append("users", file);
        setbatchFile(formData);

        setFilename(file.name);
        toast({
          title: "File Upload",
          description: "Your file is ready for upload",
          status: "success",
        });
      }
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const submitFile = () => {
    setIsSubmitting(true);
    UserAdminService.createUserBulk(batchFile)
      .then((res) => {
        toast({
          title: "Bulk User",
          description: "User(s) created successfully",
          status: "success",
          duration: 2000,
        });
        navigate(Adminroutes.UserRoles); // route to listing page
        setFilename("");
        setbatchFile(null);
      })
      .catch((err) => {
        toast({
          title: "Bulk Course",
          description: `${err.response.data.message}`,
          status: "error",
          duration: 2000,
        });
      }).finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Box minHeight="100vh" pb="30px" bg="#F9F8F8">
        <Container
          width={{ lg: "40%", md: "80%", sm: "95%", base: "95%" }}
          maxWidth={"84%"}
          px={0}
          pt="60px"
          right={0}
          bg="F9F8F8"
          mx="auto"
        >
          <Box
            mb="60px"
            display="flex"
            alignItems="center"
            border="1px solid #616161"
            padding={"5px 12px"}
            width="fit-content"
            borderRadius="5px"
            cursor="pointer"
          >
            <HiArrowNarrowLeft color="#616161" fontSize="20px" />
            <Text
              fontSize="14px"
              color="#616161"
              pl="5px"
              onClick={() => navigate(Adminroutes.UserRoles)}
              fontWeight={700}
            >
              Back to Staff
            </Text>
          </Box>
          <Box
            bg="white"
            px={["20px", "25px", "40px", "40px"]}
            py="60px"
            boxShadow="sm"
            rounded="lg"
            height="auto"
            mb="30px"
          >
            <Flex justifyContent={"space-between"}>
              <Text fontWeight="700" fontSize="24px" color="#1E1E1E">
                New User
              </Text>
              <ExportExcel
                title="Download Template"
                excelData={ExcelDataExport}
                fileName={"User Bulk Template"}
              />
            </Flex>
            <Tabs colorScheme="red">
              <TabList
                py="10px"
                px="30px"
                bg="white"
                justifyContent="space-between"
              >
                <Tab>Single User</Tab>
                <Tab>Bulk User</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <Box mt={4}>
                    <form onSubmit={formik.handleSubmit}>
                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.firstName && formik.touched.firstName
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            First Name{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Input
                            bg="inputText.500"
                            placeholder="Enter first name"
                            value={formik.values.firstName}
                            name="firstName"
                            onChange={formik.handleChange}
                            fontSize={12}
                          />
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.firstName}
                          </FormErrorMessage>
                        </FormControl>
                        <FormControl
                          isInvalid={
                            formik.errors.lastName && formik.touched.lastName
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Last Name{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Input
                            bg="inputText.500"
                            placeholder="Enter last name"
                            value={formik.values.lastName}
                            name="lastName"
                            onChange={formik.handleChange}
                            fontSize={12}
                          />
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.lastName}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>

                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.emailAddress &&
                            formik.touched.emailAddress
                              ? true
                              : false
                          }
                        >
                          <FormLabel color="brand.subtitle" fontSize={13}>
                            Email Address{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <InputGroup>
                            <InputLeftElement
                              color="brand.subtitle"
                              pointerEvents="none"
                              children={<MdMailOutline />}
                            />
                            <Input
                              type="email"
                              id="emailAddress"
                              name="emailAddress"
                              placeholder="alex@gmail.com"
                              onChange={formik.handleChange}
                              fontSize={13}
                            />
                          </InputGroup>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.emailAddress}{" "}
                          </FormErrorMessage>
                        </FormControl>
                        <FormControl
                          isInvalid={
                            formik.errors.phoneNumber &&
                            formik.touched.phoneNumber
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Phone Number{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Input
                            type="number"
                            id="phoneNumber"
                            name="phoneNumber"
                            placeholder="080*******"
                            onChange={formik.handleChange}
                            fontSize={13}
                          />

                          <FormErrorMessage fontSize={12}>
                            {formik.errors.phoneNumber}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>

                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.category && formik.touched.category
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            User Category{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Select
                            ref={courseFormatRef}
                            variant="outline"
                            bg="inputText.500"
                            size="md"
                            fontSize={12}
                            placeholder="Select category"
                            value={formik.values.category}
                            name="category"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            color="brand.subtitle"
                          >
                            {category.map((each) => (
                              <option key={each} value={each}>
                                {" "}
                                {each}{" "}
                              </option>
                            ))}
                          </Select>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.category}
                          </FormErrorMessage>
                        </FormControl>

                        {/* <FormControl
                          isInvalid={
                            formik.errors.category && formik.touched.category
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            User Role{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Select
                            ref={courseFormatRef}
                            variant="outline"
                            bg="inputText.500"
                            size="sm"
                            fontSize={12}
                            placeholder="Select role"
                            value={formik.values.role}
                            name="role"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            color="brand.subtitle"
                          >
                            {roles &&
                              roles.length > 0 &&
                              roles.map((each) => (
                                <option key={each.id} value={each.name}>
                                  {" "}
                                  {each.name}{" "}
                                </option>
                              ))}
                          </Select>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.role}
                          </FormErrorMessage>
                        </FormControl> */}
                        {/* <FormControl
                          isInvalid={
                            formik.errors.category && formik.touched.category
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Department{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Select
                            ref={courseFormatRef}
                            variant="outline"
                            bg="inputText.500"
                            size="sm"
                            fontSize={12}
                            placeholder="Select department"
                            value={formik.values.department_id}
                            name="department_id"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            color="brand.subtitle"
                          >
                            {departments &&
                              departments.length > 0 &&
                              departments.map((each) => (
                                <option key={each.id} value={each.id}>
                                  {" "}
                                  {each.name}{" "}
                                </option>
                              ))}
                          </Select>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.department_id}
                          </FormErrorMessage>
                        </FormControl> */}

                        {["MIS Director", "MIS Admin"].includes(
                          formik.values.category
                        ) && (
                          <FormControl
                            isInvalid={
                              formik.errors.department_id &&
                              formik.touched.department_id
                                ? true
                                : false
                            }
                          >
                            <FormLabel
                              fontWeight="normal"
                              color="brand.3"
                              fontSize={13}
                            >
                              Department{" "}
                              <Text as="span" color="red">
                                *
                              </Text>
                            </FormLabel>
                            <Select
                              variant="outline"
                              bg="inputText.500"
                              size="sm"
                              fontSize={12}
                              placeholder="Select department"
                              value={formik.values.department_id}
                              name="department_id"
                              onChange={(e) => {
                                formik.handleChange(e);
                                // formik.setFieldValue(
                                //   "department_id",
                                //   e.target.value
                                // );
                              }}
                              color="brand.subtitle"
                            >
                              {departments.map((each) => (
                                <option key={each.id} value={each.id}>
                                  {each.name}
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage fontSize={12}>
                              {formik.errors.department_id}
                            </FormErrorMessage>
                          </FormControl>
                        )}
                      </Stack>

                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.dob && formik.touched.dob
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Date of Birth{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <InputGroup>
                            <Input
                              placeholder="Select Date of Birth"
                              type="date"
                              bg="inputText.500"
                              name="dob"
                              value={formik.values.dob}
                              onChange={formik.handleChange}
                              fontSize={12}
                            />
                            {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                          </InputGroup>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.dob}
                          </FormErrorMessage>
                        </FormControl>

                        <FormControl
                          isInvalid={
                            formik.errors.gender && formik.touched.gender
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Gender{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <Select
                            ref={courseFormatRef}
                            variant="outline"
                            bg="inputText.500"
                            size="md"
                            fontSize={12}
                            placeholder="Select gender"
                            value={formik.values.gender}
                            name="gender"
                            onChange={(e) => {
                              formik.handleChange(e);
                            }}
                            color="brand.subtitle"
                          >
                            {gender.map((each) => (
                              <option key={each.id} value={each.title}>
                                {" "}
                                {each.title}{" "}
                              </option>
                            ))}
                          </Select>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.gender}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>

                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                        mt={6}
                        spacing={10}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.password && formik.touched.password
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Password{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <InputGroup>
                            <Input
                              placeholder="Enter password"
                              type="password"
                              bg="inputText.500"
                              name="password"
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              fontSize={12}
                            />
                            {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                          </InputGroup>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.password}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>

                      <Stack
                        mb={["10px", "10px", "25px", "25px"]}
                        direction={["column", "column", "row", "row"]}
                        mt={6}
                        spacing={10}
                      >
                        <FormControl
                          isInvalid={
                            formik.errors.confirm_password &&
                            formik.touched.confirm_password
                              ? true
                              : false
                          }
                        >
                          <FormLabel
                            fontWeight="normal"
                            color="brand.3"
                            fontSize={13}
                          >
                            Confirm Password{" "}
                            <Text as="span" color="red">
                              *
                            </Text>
                          </FormLabel>
                          <InputGroup>
                            <Input
                              placeholder="Enter password again..."
                              type="password"
                              bg="inputText.500"
                              name="confirm_password"
                              value={formik.values.confirm_password}
                              onChange={formik.handleChange}
                              fontSize={12}
                            />
                            {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                          </InputGroup>
                          <FormErrorMessage fontSize={12}>
                            {formik.errors.confirm_password}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>
                      <Flex mt={8} justifyContent={"flex-end"}>
                        <Button
                          cursor="pointer"
                          size="sm"
                          px={6}
                          bg="red"
                          color="white"
                          colorScheme="red"
                          type="submit"
                          isLoading={formik.isSubmitting}
                          fontSize={14}
                          borderRadius={"4px"}
                        >
                          CREATE USER
                        </Button>
                      </Flex>
                    </form>
                  </Box>
                </TabPanel>
                <TabPanel>
                  <Box>
                    <form>
                      <FormLabel
                        fontWeight="700"
                        color="#757575"
                        fontSize="14px"
                      >
                        Upload User Template
                      </FormLabel>
                      <div {...getRootProps({ style })}>
                        <input {...getInputProps()} />

                        {isDragActive ? (
                          <p>Drop the files here ...</p>
                        ) : (
                          <p
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              boxSizing: "border-box",
                            }}
                          >
                            {filename !== "" ? (
                              <Text>{filename}</Text>
                            ) : (
                              <span>
                                Drag and drop or browse file <br /> Only
                                Excel(.xsl) files allowed{" "}
                              </span>
                            )}
                          </p>
                        )}
                      </div>

                      <Flex mt={12} justifyContent="end">
                        <Button
                          colorScheme="red"
                          size="sm"
                          px={6}
                          onClick={() => {
                            submitFile();
                          }}
                          fontSize={12}
                          disabled={isSubmitting}
                        >
                          {" "}
                          Save
                        </Button>
                      </Flex>
                    </form>
                  </Box>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NewUser;
